export default __webpack_public_path__ + "static/media/image-study-board-2-m@2x.a2475eaf.png";